import { Api } from "./Api";
import * as apiFactory from "./ApiFactory";

import type { BrandSecurityConfiguration } from "@/models/BrandSecurityConfig";

export async function getBrandSecurityConfig(clientName: string, brand: string): Promise<BrandSecurityConfiguration> {
  const client: Api = await apiFactory.WithBearer();
  return await client.get<BrandSecurityConfiguration>(["api/BrandSecurityConfiguration", clientName, brand]);
}
